<main class="h-[calc(100vh-68px)] flex flex-col items-center">
  <div class="flex-grow flex flex-col justify-center items-center gap-y-6">
    <h1 class="text-3xl">
      Добро пожаловать в
      <app-aurora-text class="font-bold">Гринландию</app-aurora-text>
    </h1>

    <div class="flex gap-x-4">
      <button
        appearance="floating"
        tuiButton
        class="cursor-pointer"
        [routerLink]="['/', RouteNames.PRE_ORDERS_PAGE]"
      >
        Предзаказы
      </button>
      <button
        appearance="floating"
        tuiButton
        class="cursor-pointer"
        [routerLink]="['/', RouteNames.KANBAN_PAGE]"
      >
        Канбан
      </button>
      <button
        appearance="floating"
        tuiButton
        class="cursor-pointer"
        [routerLink]="['/', RouteNames.JOURNAL_PAGE]"
      >
        Журнал
      </button>
    </div>
  </div>
</main>
